export function ApiKeysManager({ keys, loading, newKey, error, generating, onGenerate, onRevoke }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8" data-testid="api-keys-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold">API Keys</h2>
        <button
          onClick={onGenerate}
          disabled={generating || keys.length >= 3}
          className="bg-[#0066FF] text-white px-5 py-2.5 font-bold hover:bg-[#0052CC] transition-colors disabled:opacity-50 rounded-lg text-sm"
          data-testid="generate-key-btn"
        >
          {generating ? "Generating..." : "+ Generate New Key"}
        </button>
      </div>
      {error && (
        <div className="bg-red-50 border border-red-500 text-red-700 p-3 mb-4 text-sm rounded-lg">{error}</div>
      )}

      {newKey && (
        <div className="bg-green-50 border border-green-500 p-4 mb-4 rounded-lg" data-testid="new-key-display">
          <p className="font-bold text-green-800 mb-2">New API Key Generated</p>
          <p className="text-sm text-green-700 mb-2">Copy this key now. It won't be shown again.</p>
          <div className="flex items-center gap-2">
            <code className="flex-1 bg-white p-3 text-sm font-mono border rounded break-all" data-testid="new-key-value">
              {newKey}
            </code>
            <button
              onClick={() => navigator.clipboard.writeText(newKey)}
              className="bg-green-600 text-white px-4 py-2 font-bold rounded-lg text-sm shrink-0"
              data-testid="copy-new-key"
            >
              Copy
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : keys.length === 0 ? (
        <p className="text-gray-500 text-sm">No API keys yet. Generate one to get started.</p>
      ) : (
        <div className="space-y-3">
          {keys.map((k) => (
            <div
              key={k.prefix}
              className="flex items-center justify-between p-4 border border-gray-100 rounded-lg"
              data-testid={`key-${k.prefix}`}
            >
              <div>
                <p className="font-medium">{k.name}</p>
                <p className="text-sm text-gray-500 font-mono">{k.prefix}...</p>
                <p className="text-xs text-gray-400">
                  Created: {k.created_at ? new Date(k.created_at).toLocaleDateString() : "N/A"} &bull; Used today:{" "}
                  {k.usage_today || 0}/1000
                </p>
              </div>
              <button
                onClick={() => onRevoke(k.prefix)}
                className="text-sm text-red-500 hover:text-red-700 font-bold"
                data-testid={`revoke-${k.prefix}`}
              >
                Revoke
              </button>
            </div>
          ))}
        </div>
      )}
      <p className="text-xs text-gray-400 mt-4">Max 3 keys &bull; 1,000 requests/day per key &bull; Uses your account credits</p>
    </div>
  );
}
